import { CodeIcon, GlobeIcon } from "lucide-react";
import { TutorialModeSelector, TutorialMode } from "./TutorialModeSelector.js";

export function CurateToolsPicker({
  alternateLink,
  mode,
}: {
  alternateLink: string;
  mode: "local" | "portal";
}) {
  return (
    <TutorialModeSelector
      title="Choose how to curate tools"
      description="Curate the same way in the Portal or in code. Both write the same mcp-capability-filter-inbound policy, so you can switch approaches at any time."
    >
      <TutorialMode
        icon={<GlobeIcon />}
        active={mode === "portal"}
        label="In the Portal"
        description="Curate tools, prompts, and resources from the MCP Gateway Virtual Server UI. No local setup required."
        link={mode === "portal" ? undefined : alternateLink}
      />
      <TutorialMode
        icon={<CodeIcon />}
        label="In code"
        active={mode === "local"}
        description="Configure the mcp-capability-filter-inbound policy directly in your project files with the Zuplo CLI."
        link={mode === "local" ? undefined : alternateLink}
      />
    </TutorialModeSelector>
  );
}
